/* AReviews owns the rating/count and its click handler. Only localize its
   explicit empty-state label in the main product information. */
(() => {
  const observed = new WeakSet();
  const initialize = () => {
    document.querySelectorAll('.gm-murano-product__info, .product-information .product-details').forEach((root) => {
      if (observed.has(root) || root.closest('product-card, product-recommendations, quick-add-dialog')) return;
      observed.add(root);
      const update = () => {
        root.querySelectorAll('.areviews_no_reviews_title').forEach((label) => {
          if (label.closest('product-card, product-recommendations, #az_reviews')) return;
          if (label.textContent.trim() !== 'Escreva sua avaliação') label.textContent = 'Escreva sua avaliação';
        });
      };
      update();
      new MutationObserver(update).observe(root, { childList: true, subtree: true, characterData: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
